import { t } from "i18next";
// FE共通の定数ファイル
// NOTE: 現時点ではconstants.tsのみで定数を管理しているが、量が増えてきたらファイルを分割する

// ------------------------------
// データベース関連の定数
// ------------------------------

// フローボット一括起動時の最大レコード数
export const BOOT_MULTIPLE_RECORD_LIMIT = 200;

// ラベル付きのデータ型
export const DATA_TYPE_WITH_LABELS = ["pulldown", "check_box", "link", "lookup", "file"] as const;

// Note: 190 -> レコード数が入るエリア(80)&カラム追加ボタンエリア(110)のwidth合計
export const EXCEPT_COLUMN_WIDTH = 190;

// フッター集計から除外するデータ型
export const EXCEPT_DATA_TYPE = ["lookup", "link", "created_at", "updated_at", "member", "image"] as const;

// フッター集計タイプ
export const AGGREGATION_TYPES = [
  { name: t("constants.非表示"), type: "none" },
  { name: t("constants.空白"), type: "empty" },
  { name: t("constants.カウント"), type: "filled" },
  { name: t("constants.合計"), type: "sum" },
  { name: t("constants.平均"), type: "average" },
  { name: t("constants.最小"), type: "min" },
  { name: t("constants.最大"), type: "max" },
  { name: t("constants.チェックなし"), type: "unchecked" },
  { name: t("constants.チェックあり"), type: "checked" },
] as const;

// リレーションタイプ
export const LINK_TYPE_LIST = [
  { label: t("constants.手動で紐付けるレコードを選択"), value: "manual" },
  { label: t("constants.値が一致するレコードを自動で紐付ける"), value: "auto" },
] as const;

// DBアイコン編集用のタブリスト
export const DB_ICON_TAB_LIST = [
  { tabName: t("constants.すべて"), iconKey: "recently" },
  { tabName: t("constants.アプリ"), iconKey: "app" },
  { tabName: t("constants.アイコン"), iconKey: "original" },
  { tabName: t("constants.絵文字"), iconKey: "emoji" },
] as const;

// 手動紐付け時に表示可能なデータ型
export const MANUAL_RELATION_DISPLAYABLE_DATA_TYPE = [
  "string",
  "long_text",
  "number",
  "datetime",
  "date",
  "boolean",
  "pulldown",
  "check_box",
  "formula",
  "file",
  "created_at",
  "updated_at",
] as const;

// ------------------------------
// フローボット関連の定数
// ------------------------------

// DBオペレーションのOneDriveの項目リスト

export const ONE_DRIVE_ITEM_LIST = [
  "drive_id",
  "file_name",
  "item_id_in_one_drive",
  "worksheet_name_in_one_drive",
  "worksheet_range",
] as const;

// DBオペレーションのSharePointの項目リスト
export const SHAREPOINT_ITEM_LIST = [
  "site_id",
  "file_name",
  "item_id_in_sharepoint",
  "worksheet_name_in_sharepoint",
  "worksheet_range",
] as const;

// 書類発行のOneDriveの項目リスト

export const ONE_DRIVE_TEMPLATE_ITEM_LIST = ["drive_id", "file_name", "item_id_in_one_drive"] as const;
export const ONE_DRIVE_ISSUANCE_ITEM_LIST = [
  "parent_file_name",
  "parent_id_in_one_drive",
  "exported_file_name",
] as const;

// 書類発行のSharePointの項目リスト

export const SHAREPOINT_TEMPLATE_ITEM_LIST = ["site_id", "file_name", "item_id_in_sharepoint"] as const;
export const SHAREPOINT_ISSUANCE_ITEM_LIST = [
  "parent_file_name",
  "parent_id_in_sharepoint",
  "exported_file_name",
] as const;

// 取得した値の変換オペレーションのmergePdfの対象ファイル上限数
export const MAX_TARGET_OUTPUT_NAME_LENGTH = 10;

// export const SAMPLE_CONSTANT = "sample";

// RPAのキーボード操作のキーリスト
export const RPA_KEYBOARD_KEY_LIST = [
  { keyValue: "Enter", displayName: "Enter" },
  { keyValue: "Escape", displayName: "Esc" },
  { keyValue: "Tab", displayName: "Tab" },
  { keyValue: "ArrowUp", displayName: "↑" },
  { keyValue: "ArrowDown", displayName: "↓" },
] as const;

// 連携希望アプリ申請フォームのURL
export const CONNECTING_APP_FORM_URL = "https://yoom.fun/timetechnologies/forms/shared/ZpFtWE6pX53PxMloxcDjyA";

// web会議トリガー関連コンテンツのページネーション
export const WEB_MEETING_TRIGGER_RESULT_FORM_PAGINATION_LIMIT = 8;
